import ko from '@tko/build.knockout';
import $ from 'jquery';
import _ from 'lodash';
import FormatterCommon from './formatter-common';
import GridFormatterCommon from './grid-formatter-common';
import FilterFormatter from './filter-formatter';
import DataRepository from '../data-framework/data-repository';



    function RoomGridFormatter(params, observableOptions) {

        this.observableOptions = observableOptions;

        this.gridFormatterCommon = new GridFormatterCommon();
        this.filterFormatter = new FilterFormatter();
        this.formatterCommon = FormatterCommon;

        this.dataRepository = DataRepository.getInstance();
        this.observableFormattedData = ko.observable();

        this.subscriptions = [];
    }

    RoomGridFormatter.prototype.ComposeData = function(sourceList, options, optionsUpdated, metadata, formatters) {
        var headers = metadata.searchgrid.headers;
        var rowProperties = metadata.searchgrid.rowProperties;
        const widths = metadata.searchgrid.columnWidths;

        if (_.isEmpty(sourceList)) {
            return formatters.gridFormatterCommon.composeEmpty(headers, rowProperties, widths);
        }

        var searchFilter = formatters.filterFormatter.toTypeaheadFilter(_.get(options, 'filter'));

        var list = _.chain(sourceList).map(function(item) {
            return _.assignIn({}, item, {
                name: formatters.formatterCommon.sanitize(item.name),
                endpointNames: formatters.formatterCommon.sanitize(_.map(item.endpoints, 'name').join(', ')),
                tagNames: _.isArray(item.tags) ? formatters.formatterCommon.sanitize(item.tags.join(', ')) : '',
                edit: '<i class="fa fa-edit edit-icon" title="Edit"></i>'
            });
        }).filter(function(item) {
            return _.isEmpty(searchFilter) || formatters.filterFormatter.matchAll(item, searchFilter);
        })
        .value();

        var sortedList = formatters.gridFormatterCommon.sortList(list, metadata.searchgrid.sortableProperties, options);
        var pagedList = formatters.gridFormatterCommon.pageList(sortedList, options);


        this.allAcrossSelectedObs = ko.observable(false);

        return {
            maxCount: list.length,
            rows: pagedList,
            rowProperties: rowProperties,
            origlist: sortedList,
            headers: headers,
            widths: widths,
            innerRowDisplayIndex: 0,
            optionsUpdated: optionsUpdated
        };
    };

    RoomGridFormatter.prototype.RefreshData = function (optionsUpdated) {
        this.observableFormattedData(
            this.ComposeData(
                this.dataRepository.rooms(),
                this.observableOptions(),
                optionsUpdated,
                this.dataRepository.getRoomMetadata(),
                {
                    gridFormatterCommon: this.gridFormatterCommon,
                    filterFormatter: this.filterFormatter,
                    formatterCommon: this.formatterCommon
                }
            )
        );
    };

    RoomGridFormatter.prototype.initialize = function (dataRepository) {
        this.dataRepository = dataRepository;

        this.subscriptions.push(dataRepository.rooms.subscribe(_.bind(this.RefreshData, this)));
        this.subscriptions.push(this.observableOptions.subscribe(_.bind(this.RefreshData, this, true)));

        this.RefreshData();
    };

    RoomGridFormatter.prototype.getObservableData = function () {
        return this.observableFormattedData;
    };

    RoomGridFormatter.prototype.dispose = function() {
        this.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    };

    export default RoomGridFormatter;
